<template>
  <div class="laya-course-new-view">
    <h3>Neuen Kurs erstellen</h3>
    <hr>
    <form class="mt-3">
      <div class="form-group row">
        <label for="new-course-name" class="col-3 col-form-label">
          Kursname
        </label>
        <div class="col">
          <input id="new-course-name"
                 type="text"
                 class="form-control"
                 v-model="newCourse.name"
                 placeholder="Kursname"
                 aria-describedby="name-err">
        </div>
      </div>
      <div class="form-group row">
        <label for="new-course-category" class="col-3 col-form-label">
          Kategorie
        </label>
        <div class="col">
          <input id="new-course-category"
                 type="text"
                 class="form-control"
                 v-model="newCourse.category"
                 placeholder="Kategorie">
        </div>
      </div>
      <div class="form-group row">
        <div class="col">
          <span class="text-danger form-control-plaintext text-right">
            {{msg}}
          </span>
        </div>
        <div class="col-4">
          <button type="submit"
                  class="btn btn-block btn-primary"
                  @click.prevent="storeNewCourse">
            <i class="fas fa-check"></i> Speichern
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import http from "axios";
import * as i18n from '@/i18n/courses'

import courseService from '@/misc/course-service';

export default {
  data() {
    return {
      msg: "",
      newCourse: {}
    }
  },
  computed: {
    ...mapState(["note", "auth", "profile"]),
  },
  methods: {

    storeNewCourse() {
      const {newCourse, auth, profile} = this;

      if (!newCourse.name || !newCourse.category) {
        this.msg = "Bitte füllen Sie die Felder Kursname und Kategorie aus."
        return
      }

      return courseService.courseExists(newCourse.name, newCourse.category, profile.lang)
          .then(exists => {
            if (exists) {
              this.msg = 'Ein Kurs mit diesem Name existiert bereits.'
              return
            } else {
              /* create course */
              http.post('courses', {
                ...newCourse,
                language: profile.lang,
                authorId: auth.userId,
              }).then(({ data }) => {
                this.$router.push(`/courses/${data.id}/1`)

                /* create storage */
                return http.post('storage', {
                  name: data.id
                })
              }).catch((err) => {
                console.log(err)
                this.msg = 'Beim Speichern ist ein Fehler aufgetreten'
              })
            }
          })
    }
  }
}
</script>
